'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var browser_utils = require('../browser.utils-bfcc05c6.js');
var viewport_utils = require('../viewport.utils-0c2b4e2b.js');
require('../tslib.es6-130a177d.js');
require('styled-components');



exports.forEdge = browser_utils.forEdge;
exports.forIE = browser_utils.forIE;
exports.forIEandEdge = browser_utils.forIEandEdge;
exports.forSafari = browser_utils.forSafari;
exports.forSafari14andBefore = browser_utils.forSafari14andBefore;
exports.isIE = browser_utils.isIE;
exports.safari10MinMaxFallBack = browser_utils.safari10MinMaxFallBack;
exports.breakPointToMediaQuery = viewport_utils.breakPointToMediaQuery;
exports.default = viewport_utils.breakpoints;
exports.forDesktop = viewport_utils.forDesktop;
exports.forExtraWideScreens = viewport_utils.forExtraWideScreens;
exports.forIPhone5 = viewport_utils.forIPhone5;
exports.forMidDesktop = viewport_utils.forMidDesktop;
exports.forMidWideScreens = viewport_utils.forMidWideScreens;
exports.forMobile = viewport_utils.forMobile;
exports.forMobileSmall = viewport_utils.forMobileSmall;
exports.forSemiWideScreens = viewport_utils.forSemiWideScreens;
exports.forTablet = viewport_utils.forTablet;
exports.forUltraWideScreens = viewport_utils.forUltraWideScreens;
exports.forWideScreens = viewport_utils.forWideScreens;
exports.getBreakPointValue = viewport_utils.getBreakPointValue;
exports.getMediaStringValue = viewport_utils.getMediaStringValue;
exports.iphoneXMediaQuery = viewport_utils.iphoneXMediaQuery;
exports.isDesktop = viewport_utils.isDesktop;
exports.isMidDesktop = viewport_utils.isMidDesktop;
exports.isMobile = viewport_utils.isMobile;
exports.isMobileV2 = viewport_utils.isMobileV2;
exports.isSemiWideScreen = viewport_utils.isSemiWideScreen;
exports.isTablet = viewport_utils.isTablet;
exports.isTabletV2 = viewport_utils.isTabletV2;
exports.underDesktop = viewport_utils.underDesktop;
exports.underExtraWideScreens = viewport_utils.underExtraWideScreens;
exports.underIPhone5 = viewport_utils.underIPhone5;
exports.underMidDesktop = viewport_utils.underMidDesktop;
exports.underMidWideScreens = viewport_utils.underMidWideScreens;
exports.underMobile = viewport_utils.underMobile;
exports.underMobileSmall = viewport_utils.underMobileSmall;
exports.underSemiWideScreens = viewport_utils.underSemiWideScreens;
exports.underTablet = viewport_utils.underTablet;
exports.underUltraWideScreens = viewport_utils.underUltraWideScreens;
exports.underWideScreens = viewport_utils.underWideScreens;
//# sourceMappingURL=index.js.map
